import BankAccordian from './BankAccordian'
export default BankAccordian
